import gsap from "gsap";
import ScrollTrigger from "gsap/dist/ScrollTrigger";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import "swiper/css/thumbs";
import TabsSlider from "../modules/TabsSlider";
gsap.registerPlugin(ScrollTrigger);

class About {
	constructor() {
		this.init();
	}

	init() {
		this.initModules();
	}

	initModules() {
		// Init Modules here
		const tabs = document.querySelector("[js-tabs-container]");
		tabs && new TabsSlider(tabs);
	}
}

if (document.readyState === "loading") {
	// Loading hasn't finished yet
	window.addEventListener("DOMContentLoaded", () => new About());
} else {
	// `DOMContentLoaded` has already fired
	new About();
}
